'use client';

import { useEffect } from 'react';

/**
 * Registers /sw.js on mount — production only.
 *
 * Never registers in development (avoids stale Next.js chunk issues) or in
 * the test environment (NODE_ENV === 'test').  The check is inside the effect
 * so tests can override process.env.NODE_ENV at call-time via vi.stubEnv.
 */
export function ServiceWorkerRegistrar() {
  useEffect(() => {
    // Production-only: dev SW registration causes stale chunk issues
    if (process.env.NODE_ENV !== 'production') return;
    if (!('serviceWorker' in navigator)) return;

    navigator.serviceWorker
      .register('/sw.js')
      .catch((err) => console.error('[SW] Registration failed:', err));
  }, []);

  return null;
}
